import React from "react";
import { 
  Container, 
  Box, 
  Skeleton, 
  Card, 
  CardContent,
  Grid
} from "@mui/material";

function ManageRoomsPageSkeleton() {
  return (
    <Container sx={{ mt: 4 }}>
      {/* Header section */}
      <Box sx={{ mb: 4 }}>
        <Skeleton variant="text" width={300} height={48} sx={{ mb: 2 }} />
        <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
          <Skeleton variant="rectangular" width={120} height={40} />
          <Skeleton variant="rectangular" width={150} height={40} />
        </Box>
      </Box>

      {/* Room cards grid */}
      <Grid container spacing={3}>
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                {/* Room image */}
                <Skeleton 
                  variant="rectangular" 
                  width="100%" 
                  height={200} 
                  sx={{ mb: 2, borderRadius: 1 }} 
                />
                
                {/* Room name */}
                <Skeleton variant="text" width="80%" height={28} sx={{ mb: 1 }} />
                
                {/* Room details */}
                <Box sx={{ mb: 2 }}>
                  <Skeleton variant="text" width="60%" height={20} sx={{ mb: 1 }} />
                  <Skeleton variant="text" width="70%" height={20} sx={{ mb: 1 }} />
                  <Skeleton variant="text" width="50%" height={20} />
                </Box>
                
                {/* Action buttons */}
                <Box sx={{ 
                  display: "flex", 
                  gap: 1, 
                  justifyContent: "space-between",
                  mt: 2 
                }}>
                  <Skeleton variant="rectangular" width={80} height={36} />
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Skeleton variant="rectangular" width={36} height={36} />
                    <Skeleton variant="rectangular" width={36} height={36} />
                    <Skeleton variant="rectangular" width={36} height={36} />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default ManageRoomsPageSkeleton;